/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal Weight Calculator (by Height) — Toolverse`)
};

const es_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal (por Altura) — Toolverse`)
};

const de_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealgewicht-Rechner (nach Körpergröße) — Toolverse`)
};

const nl_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideaal Gewicht Calculator (op basis van lengte) — Toolverse`)
};

const fr_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Poids Idéal (Selon la Taille) — Toolverse`)
};

const it_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di peso ideale (per altezza) — Toolverse`)
};

const pt_br2_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal (por Altura) — Toolverse`)
};

const pt_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal (por Altura) — Toolverse`)
};

const ja_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重計算機(身長から算出) — Toolverse`)
};

const zh_iw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重计算器（按身高）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_meta_title", locale)
	if (locale === "en") return en_iw_meta_title(inputs)
	if (locale === "es") return es_iw_meta_title(inputs)
	if (locale === "de") return de_iw_meta_title(inputs)
	if (locale === "nl") return nl_iw_meta_title(inputs)
	if (locale === "fr") return fr_iw_meta_title(inputs)
	if (locale === "it") return it_iw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_iw_meta_title(inputs)
	if (locale === "pt") return pt_iw_meta_title(inputs)
	if (locale === "ja") return ja_iw_meta_title(inputs)
	return zh_iw_meta_title(inputs)
};